var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8944 17.4713C13.187 17.7641 13.187 18.2387 12.8944 18.5316L11.9625 19.4691C9.91033 21.5199 6.58416 21.5189 4.53328 19.4667C2.48241 17.4145 2.48346 14.0884 4.53562 12.0375L6.79688 9.77625C8.76196 7.80959 11.9195 7.71586 13.9978 9.5625C14.3085 9.83795 14.337 10.3131 14.0616 10.6237C13.7861 10.9344 13.311 10.963 13.0003 10.6875C11.516 9.36936 9.26156 9.43635 7.85813 10.8403L5.59688 13.0988C4.13211 14.5635 4.13211 16.9384 5.59688 18.4031C7.06164 19.8679 9.43649 19.8679 10.9012 18.4031L11.8331 17.4713C11.9738 17.3304 12.1647 17.2513 12.3638 17.2513C12.5628 17.2513 12.7537 17.3304 12.8944 17.4713ZM19.4644 4.53375C17.4122 2.48613 14.0897 2.48613 12.0375 4.53375L11.1056 5.46656C10.8128 5.75962 10.813 6.23455 11.1061 6.52734C11.3991 6.82014 11.8741 6.81993 12.1669 6.52688L13.0988 5.595C14.5635 4.13024 16.9384 4.13024 18.4031 5.595C19.8679 7.05976 19.8679 9.43461 18.4031 10.8994L16.1419 13.1625C14.7377 14.5656 12.4833 14.6314 10.9997 13.3125C10.7987 13.1343 10.518 13.0769 10.2632 13.1618C10.0084 13.2468 9.81826 13.4612 9.76442 13.7243C9.71059 13.9875 9.80123 14.2593 10.0022 14.4375C12.08 16.2846 15.2375 16.1917 17.2031 14.2256L19.4644 11.9644C21.5132 9.91194 21.5132 6.58806 19.4644 4.53562V4.53375Z",
    fill: "#121417"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.3048c5c336e4f86ab304b092948bdcfd.svg";
export { ForwardRef as ReactComponent };